import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

import { BaseDataService, HttpService } from "./base.service";

import { Manifest } from "./../../resources";
import { Observable } from "rxjs";

export interface ManifestServiceFilters {
  pageSize?: number;
  page?: number;
  limit?: number;
  search?: string;
  friendlyName?: string;
}

@Injectable()
export class ManifestService extends BaseDataService<Manifest> {
  constructor(http: HttpService) {
    super(http, "manifest");
  }

  createInstance(options: any): Manifest {
    return new Manifest(options);
  }

  approve(manifestId: number, status: boolean): Observable<Manifest> {
    return this.runCommand("approve", { id: manifestId, approved: status }).pipe(map((x) => x));
  }

  report(trackNo: string) {
    return this.http.downloadFile(`${this.resourceUrl}/${trackNo}/report`);
  }

  print(trackNo: string) {
    return this.http.downloadFile(`${this.resourceUrl}/${trackNo}/print`);
  }

  exportList(searchParams: ManifestServiceFilters) {
    return this.http.exportList(`${this.resourceUrl}/exportList`, { searchParams });
  }

  filterBy(filters: ManifestServiceFilters) {
    console.log(filters);
    return this.all(filters);
  }

  getItems(id: string) {
    return this.http.request(`${this.resourceUrl}/${id}/items`);
  }

  updateKeywords(manifestId: number, unlinked: number[], linked: number[]) {
    return this.runLinkageUpdateCmd("updateKeywords", manifestId, unlinked, linked);
  }

  runLinkageUpdateCmd(cmd: string, manifestId: number, unlinked: number[], linked: number[]) {
    return this.runCommand(cmd, { manifestId, unlinked, linked }).pipe(map((x) => true));
  }

  getUnshipedManifests(searchParams: ManifestServiceFilters) {
    console.log(searchParams);
    return this.http
      .request(`${this.resourceUrl}/unshipped`, { searchParams })
      .pipe(map((response) => <any>this.processArrayOfEntities(response, (options) => options)));
  }
}
